export default {
    when() {
        return document.querySelectorAll('.counter-header').length > 0;
    },

    counters: [],

    mounted() {
        document.querySelectorAll('.counter-header').forEach((header) => {
            this.counters.push(new Counter(header, header.dataset));
        });
    },

    destroy() {
        this.counters.forEach((counter) => counter.unbind());
    },
};

/* -------------------------------------------------------
 * Counter Class
 * ----------------------------------------------------- */

class Counter {
    constructor(container, options = {}) {
        this.container = container;
        this.options = {
            numberSelector: '.number',
            duration: parseInt(options.duration) || 2000,
            ...options,
        };

        this.numberEls = [
            ...this.container.querySelectorAll(this.options.numberSelector),
        ];
        this.hasRun = false;

        this.observer = new IntersectionObserver(
            (entries) => this.handleIntersect(entries),
            { threshold: 0.4 }
        );

        this.bind();
    }

    bind() {
        this.observer.observe(this.container);
    }

    unbind() {
        this.observer.disconnect();
    }

    handleIntersect(entries) {
        entries.forEach((entry) => {
            if (entry.isIntersecting && !this.hasRun) {
                this.animateAll();
                this.hasRun = true;
            }
        });
    }

    animateAll() {
        this.numberEls.forEach((el) => {
            const original = el.innerHTML.trim();
            const parsed = this.parseNumber(original);

            if (parsed !== null) {
                this.animate(
                    el,
                    parsed.start,
                    parsed.end,
                    parsed.prefix,
                    parsed.suffix
                );
            }
        });
    }

    /* -------------------------------------------------------
     * Number Parsing
     * ----------------------------------------------------- */

    parseNumber(value) {
        value = value.trim();

        // Extract prefix (before first digit or minus sign or decimal)
        const prefixMatch = value.match(/^[^\d-]+/);
        const prefix = prefixMatch ? prefixMatch[0] : '';

        // Extract suffix (after last digit or decimal)
        const suffixMatch = value.match(/[^\d.]+$/);
        const suffix = suffixMatch ? suffixMatch[0] : '';

        // Extract numeric part (keep digits + dot ONLY)
        const numberStr = value.replace(/[^0-9.]/g, '');

        if (!numberStr) return null;

        const endValue = parseFloat(numberStr);

        return {
            start: 0,
            end: endValue,
            prefix,
            suffix,
        };
    }

    /* -------------------------------------------------------
     * Animation Logic
     * ----------------------------------------------------- */

    animate(el, start, end, prefix, suffix) {
        const duration = this.options.duration;
        let startTime = null;

        const step = (timestamp) => {
            if (!startTime) startTime = timestamp;
            const progress = Math.min((timestamp - startTime) / duration, 1);

            const current = progress * (end - start) + start;

            el.innerHTML = this.formatNumber(current, prefix, suffix);

            if (progress < 1) {
                requestAnimationFrame(step);
            }
        };

        requestAnimationFrame(step);
    }

    /* -------------------------------------------------------
     * Formatting Rules
     * ----------------------------------------------------- */

    formatNumber(num, prefix, suffix) {
        // Keep decimals if they exist
        const formatted = num % 1 !== 0 ? num.toFixed(2) : num.toString();
        return `${prefix}${formatted}${suffix}`;
    }
}
